// Get Group
export const GET_GROUP_REQUEST = 'GET_GROUP_REQUEST';
export const GET_GROUP_DONE = 'GET_GROUP_DONE';
export const GET_GROUP_FAILED = 'GET_GROUP_FAILED';

// Update Group
export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST';
export const UPDATE_GROUP_DONE = 'UPDATE_GROUP_DONE';
export const UPDATE_GROUP_FAILED = 'UPDATE_GROUP_FAILED';
export const UPDATE_GROUP_RESET = 'UPDATE_GROUP_RESET';